const initialState = {
    refreshTablet: false,
};

const taskTemplateReducer = (state = initialState, action: { type: string; payload?: any }) => {
    switch (action.type) {
        case 'REFRESH_TABLE_TASK_TEMPLATE_TOGGLE':
            return { ...state, refreshTablet: action.payload };
        default:
            return state;
    }
};

export default taskTemplateReducer;